var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDirections = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "directions_svg__icon directions_svg__icon-tabler directions_svg__icon-tabler-directions",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 5h10l2 2-2 2H9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M13 13H6l-2 2 2 2h7a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1M12 22v-5M12 13V9M12 5V3"
})));
export default SvgDirections;